// UTILS
import { defineStore } from "pinia"
import { ref, computed } from "vue"

// API
import { getQuestions, getAudio } from "@/api/s3/index"

// STORES
import { useHelpStore } from "@/components/af/Help/help.store.js"

// MACHINE
import { driveActor } from "@/features/drive/machines/driveMachine"

// TYPES
import type { Ref } from "vue"
import type { Question } from "@/features/drive/store/drive.types"

export const useQuestionsStore = defineStore("driveQuestionsStore", () => {
  const helpStore = useHelpStore()

  // Ref
  const items: Ref<Question[]> = ref([])
  const currentIndex: Ref<number> = ref(0)
  const isLastQuestion: Ref<boolean> = ref(false)

  // Computed
  const currentQuestion = computed<Question>(() => {
    return items.value[currentIndex.value]
  })
  const questionsLength = computed(() => items.value.length)

  /**
   * Fetch the questions for the drive assessment
   * @returns
   */
  async function fetchQuestions() {
    const data = await getQuestions({ test: "drive" })
    items.value = data.questions

    return items.value
  }

  /**
   * Fetch the audios for the drive assessment
   */
  function fetchAudios() {
    getAudio({ test: "drive" })
  }

  /**
   * Go to the next question
   * if current question is not the last one of the list, increment the index
   */
  async function goNext() {
    if (currentIndex.value === items.value.length - 1) {
      isLastQuestion.value = true
      driveActor.send({ type: "done" })
    } else {
      isLastQuestion.value = false
      currentIndex.value++
      if (helpStore.isAudioHelpAccepted) {
        helpStore.startAudioSequence()
      }
    }
  }

  /**
   * Set the current index
   * @param id
   */
  function setCurrentIndex(id: number) {
    currentIndex.value = id
  }

  return {
    questions: items.value,
    currentIndex,
    currentQuestion,
    questionsLength,
    fetchQuestions,
    fetchAudios,
    goNext,
    isLastQuestion,
    setCurrentIndex,
  }
})
